module.exports = __webpack_public_path__ + "static/media/starIcon.6f858aa0.png";